export const all = ['generateTrip'] as const

export const generationStatus = (id: string) => [...all, id, 'status']
